import { z } from "zod";
export const StorybookPayload = z.object({
    id: z.string(),
    designSystemId: z.string(),
    sourceId: z.string(),
    payload: z.any(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
